/* eslint-disable @typescript-eslint/no-explicit-any */
import { createContext } from 'react';

export const FaqContext = createContext<any>(null);
